<template>
    <div class="error-message tw-flex tw-flex-col tw-items-center tw-content-center tw-text-center tw-h-full">
        <p>Neste momento não temos ofertas activas para o seu perfil.<br><br>
        <span>A Equipa Kantar</span></p>
    </div>
</template>

<script>
export default {
    name: 'FormError',
};
</script>
